import PIcon from '@comp/project/icon/PIcon'

export default {
  install(Vue) {
    // 注册全局组件
    Vue.component(PIcon.name, PIcon)
  }
}
